export const name = 'debugDs' as const
export const DebugDsSymbol = Symbol('debugDsSymbol')
